import React from "react";

export default function StandartFrame30({ fill, frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 531 531"
    >
      <g transform={frameTextToggle}>
        <rect
          width={521}
          height={521}
          x={5}
          y={5}
          stroke={fill}
          strokeWidth={10}
          rx={260.5}
          fill="none"
        />
        <path
          fill={fill}
          d="M119.343 74.216h-9.395v9.42h9.395v-9.42ZM331.079 22.708h-9.396v9.42h9.396v-9.42ZM128.739 64.796h-9.396v9.42h9.396v-9.42ZM128.739 93.055h-9.396v9.419h9.396v-9.42ZM138.135 55.376h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M138.135 64.796h-9.396v9.42h9.396v-9.42ZM138.135 83.635h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M138.135 93.055h-9.396v9.419h9.396v-9.42ZM147.531 64.796h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M147.531 74.216h-9.396v9.42h9.396v-9.42ZM156.927 64.796h-9.396v9.42h9.396v-9.42ZM156.927 83.635h-9.396v9.42h9.396v-9.42ZM166.322 36.537h-9.395v9.42h9.395v-9.42ZM166.322 45.957h-9.395v9.42h9.395v-9.42Z"
        />
        <path
          fill={fill}
          d="M166.322 64.796h-9.395v9.42h9.395v-9.42ZM166.322 83.635h-9.395v9.42h9.395v-9.42ZM175.718 36.537h-9.396v9.42h9.396v-9.42ZM175.718 55.376h-9.396v9.42h9.396v-9.42ZM175.718 74.216h-9.396v9.42h9.396v-9.42ZM175.718 93.055h-9.396v9.419h9.396v-9.42ZM185.114 27.117h-9.396v9.42h9.396v-9.42ZM185.114 64.796h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M185.114 74.216h-9.396v9.42h9.396v-9.42ZM194.51 45.957h-9.396v9.42h9.396v-9.42Z"
        />
        <path fill={fill} d="M194.51 64.796h-9.396v9.42h9.396v-9.42Z" />
        <path
          fill={fill}
          d="M194.51 74.216h-9.396v9.42h9.396v-9.42ZM194.51 93.055h-9.396v9.419h9.396v-9.42ZM203.906 27.117h-9.396v9.42h9.396v-9.42ZM203.906 45.957h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M203.906 55.376h-9.396v9.42h9.396v-9.42ZM203.906 64.796h-9.396v9.42h9.396v-9.42Z"
        />
        <path fill={fill} d="M203.906 74.216h-9.396v9.42h9.396v-9.42Z" />
        <path fill={fill} d="M203.906 83.635h-9.396v9.42h9.396v-9.42Z" />
        <path
          fill={fill}
          d="M203.906 93.055h-9.396v9.419h9.396v-9.42ZM213.301 64.796h-9.395v9.42h9.395v-9.42Z"
        />
        <path
          fill={fill}
          d="M213.301 83.635h-9.395v9.42h9.395v-9.42ZM222.697 27.117h-9.395v9.42h9.395v-9.42ZM222.697 36.537h-9.395v9.42h9.395v-9.42ZM222.697 55.376h-9.395v9.42h9.395v-9.42ZM222.697 74.216h-9.395v9.42h9.395v-9.42ZM232.093 17.698h-9.396v9.42h9.396v-9.42ZM232.093 36.537h-9.396v9.42h9.396v-9.42ZM232.093 74.216h-9.396v9.42h9.396v-9.42ZM241.489 36.537h-9.396v9.42h9.396v-9.42ZM241.489 55.376h-9.396v9.42h9.396v-9.42ZM241.489 64.796h-9.396v9.42h9.396v-9.42ZM241.489 83.635h-9.396v9.42h9.396v-9.42ZM250.885 27.117h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M250.885 36.537h-9.396v9.42h9.396v-9.42ZM250.885 55.376h-9.396v9.42h9.396v-9.42ZM250.885 74.216h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M250.885 83.635h-9.396v9.42h9.396v-9.42ZM227.408 92.937h-9.396v9.42h9.396v-9.42ZM260.281 64.796h-9.396v9.42h9.396v-9.42ZM260.281 83.635h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M260.281 93.055h-9.396v9.419h9.396v-9.42ZM269.676 17.698h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M269.676 27.117h-9.396v9.42h9.396v-9.42ZM269.676 55.376h-9.396v9.42h9.396v-9.42ZM269.676 64.796h-9.396v9.42h9.396v-9.42ZM269.676 83.635h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M269.676 93.055h-9.396v9.419h9.396v-9.42ZM279.072 17.698h-9.396v9.42h9.396v-9.42ZM279.072 45.957h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M279.072 55.376h-9.396v9.42h9.396v-9.42ZM279.072 83.635h-9.396v9.42h9.396v-9.42ZM288.468 17.698h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M288.468 27.117h-9.396v9.42h9.396v-9.42ZM288.468 36.537h-9.396v9.42h9.396v-9.42ZM288.468 74.216h-9.396v9.42h9.396v-9.42ZM288.468 93.055h-9.396v9.419h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M297.864 27.117h-9.396v9.42h9.396v-9.42ZM297.864 55.376h-9.396v9.42h9.396v-9.42ZM297.864 64.796h-9.396v9.42h9.396v-9.42ZM297.864 93.055h-9.396v9.419h9.396v-9.42ZM307.259 36.537h-9.395v9.42h9.395v-9.42ZM307.259 45.957h-9.395v9.42h9.395v-9.42ZM307.259 74.216h-9.395v9.42h9.395v-9.42ZM316.655 17.698h-9.395v9.42h9.395v-9.42Z"
        />
        <path
          fill={fill}
          d="M316.655 27.117h-9.395v9.42h9.395v-9.42ZM316.655 36.537h-9.395v9.42h9.395v-9.42ZM316.655 55.376h-9.395v9.42h9.395v-9.42ZM316.655 83.635h-9.395v9.42h9.395v-9.42Z"
        />
        <path
          fill={fill}
          d="M316.655 93.055h-9.395v9.419h9.395v-9.42ZM326.051 64.796h-9.396v9.42h9.396v-9.42Z"
        />
        <path fill={fill} d="M326.051 74.216h-9.396v9.42h9.396v-9.42Z" />
        <path
          fill={fill}
          d="M326.051 83.635h-9.396v9.42h9.396v-9.42ZM335.447 55.376h-9.396v9.42h9.396v-9.42ZM335.447 64.796h-9.396v9.42h9.396v-9.42ZM344.843 36.537h-9.396v9.42h9.396v-9.42ZM344.843 55.376h-9.396v9.42h9.396v-9.42ZM344.843 83.635h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M344.843 93.055h-9.396v9.419h9.396v-9.42ZM354.239 27.117h-9.396v9.42h9.396v-9.42ZM354.239 36.537h-9.396v9.42h9.396v-9.42ZM354.239 45.957h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M354.239 55.376h-9.396v9.42h9.396v-9.42ZM354.239 64.796h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M354.239 74.216h-9.396v9.42h9.396v-9.42ZM363.634 45.957h-9.395v9.42h9.395v-9.42ZM363.634 64.796h-9.395v9.42h9.395v-9.42ZM363.634 83.635h-9.395v9.42h9.395v-9.42Z"
        />
        <path fill={fill} d="M373.03 45.957h-9.396v9.42h9.396v-9.42Z" />
        <path
          fill={fill}
          d="M373.03 55.376h-9.396v9.42h9.396v-9.42ZM373.03 74.216h-9.396v9.42h9.396v-9.42ZM373.03 93.055h-9.396v9.419h9.396v-9.42ZM382.426 45.957h-9.396v9.42h9.396v-9.42ZM382.426 74.216h-9.396v9.42h9.396v-9.42ZM401.218 55.376h-9.396v9.42h9.396v-9.42ZM401.218 64.796h-9.396v9.42h9.396v-9.42ZM420.036 74.21h-9.396v9.42h9.396v-9.42ZM401.218 93.055h-9.396v9.419h9.396v-9.42ZM410.613 83.635h-9.395v9.42h9.395v-9.42Z"
        />
        <path
          fill={fill}
          d="M410.613 93.055h-9.395v9.419h9.395v-9.42ZM420.009 93.055h-9.396v9.419h9.396v-9.42ZM110.359 83.573h-9.396v9.42h9.396v-9.42ZM99.657 411.309h-9.395v9.419h9.395v-9.419ZM118.385 444.863h-9.395v9.419h9.395v-9.419ZM127.781 426.023h-9.396v9.42h9.396v-9.42ZM127.781 454.282h-9.396v9.42h9.396v-9.42ZM99.657 426.023h-9.395v9.42h9.395v-9.42ZM137.177 444.863h-9.396v9.419h9.396v-9.419Z"
        />
        <path
          fill={fill}
          d="M137.177 454.282h-9.396v9.42h9.396v-9.42ZM137.177 463.702h-9.396v9.42h9.396v-9.42ZM146.573 454.282h-9.396v9.42h9.396v-9.42ZM146.573 463.702h-9.396v9.42h9.396v-9.42ZM155.969 426.023h-9.396v9.42h9.396v-9.42ZM155.969 444.863h-9.396v9.419h9.396v-9.419Z"
        />
        <path
          fill={fill}
          d="M155.969 454.282h-9.396v9.42h9.396v-9.42ZM165.364 426.023h-9.395v9.42h9.395v-9.42ZM165.364 444.863h-9.395v9.419h9.395v-9.419ZM165.364 473.122h-9.395v9.419h9.395v-9.419ZM165.364 482.541h-9.395v9.42h9.395v-9.42ZM174.76 435.443h-9.395v9.42h9.395v-9.42ZM174.76 454.282h-9.395v9.42h9.395v-9.42ZM174.76 473.122h-9.395v9.419h9.395v-9.419ZM184.156 435.443h-9.396v9.42h9.396v-9.42ZM184.156 473.122h-9.396v9.419h9.396v-9.419ZM184.156 491.961h-9.396v9.42h9.396v-9.42ZM193.552 435.443h-9.396v9.42h9.396v-9.42ZM193.552 491.961h-9.396v9.42h9.396v-9.42ZM202.948 426.023h-9.396v9.42h9.396v-9.42ZM202.948 463.702h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M212.343 435.443h-9.395v9.42h9.395v-9.42ZM212.343 482.541h-9.395v9.42h9.395v-9.42ZM212.343 491.961h-9.395v9.42h9.395v-9.42ZM221.739 444.863h-9.395v9.419h9.395v-9.419ZM221.739 463.702h-9.395v9.42h9.395v-9.42ZM221.739 473.122h-9.395v9.419h9.395v-9.419ZM221.739 491.961h-9.395v9.42h9.395v-9.42ZM419.367 415.991h-9.396v9.419h9.396v-9.419ZM231.135 435.443h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M231.135 444.863h-9.396v9.419h9.396v-9.419ZM231.135 454.282h-9.396v9.42h9.396v-9.42ZM231.135 463.702h-9.396v9.42h9.396v-9.42ZM231.135 491.961h-9.396v9.42h9.396v-9.42ZM240.531 426.023h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M240.531 435.443h-9.396v9.42h9.396v-9.42ZM240.531 444.863h-9.396v9.419h9.396v-9.419ZM240.531 463.702h-9.396v9.42h9.396v-9.42ZM240.531 482.541h-9.396v9.42h9.396v-9.42ZM249.927 444.863h-9.396v9.419h9.396v-9.419ZM249.927 491.961h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M249.927 501.325h-9.396v9.419h9.396v-9.419ZM259.323 435.443h-9.396v9.42h9.396v-9.42ZM259.323 444.863h-9.396v9.419h9.396v-9.419ZM259.323 482.541h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M268.718 435.443h-9.396v9.42h9.396v-9.42ZM268.718 454.282h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M278.114 426.023h-9.396v9.42h9.396v-9.42ZM278.114 444.863h-9.396v9.419h9.396v-9.419ZM278.114 454.282h-9.396v9.42h9.396v-9.42ZM278.114 463.702h-9.396v9.42h9.396v-9.42ZM278.114 473.122h-9.396v9.419h9.396v-9.419ZM278.114 491.961h-9.396v9.42h9.396v-9.42ZM287.51 426.023h-9.396v9.42h9.396v-9.42ZM287.51 454.282h-9.396v9.42h9.396v-9.42ZM296.906 435.443h-9.396v9.42h9.396v-9.42ZM296.906 444.863h-9.396v9.419h9.396v-9.419ZM296.906 473.122h-9.396v9.419h9.396v-9.419ZM296.906 482.541h-9.396v9.42h9.396v-9.42ZM296.906 491.961h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M278.178 501.325h-9.396v9.419h9.396v-9.419ZM306.301 444.863h-9.395v9.419h9.395v-9.419ZM306.301 454.282h-9.395v9.42h9.395v-9.42ZM306.301 491.961h-9.395v9.42h9.395v-9.42ZM315.697 426.023h-9.396v9.42h9.396v-9.42ZM315.697 473.122h-9.396v9.419h9.396v-9.419ZM325.093 435.443h-9.396v9.42h9.396v-9.42ZM325.093 444.863h-9.396v9.419h9.396v-9.419ZM325.093 454.282h-9.396v9.42h9.396v-9.42ZM325.093 463.702h-9.396v9.42h9.396v-9.42ZM325.093 473.122h-9.396v9.419h9.396v-9.419ZM325.093 491.961h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M334.489 435.443h-9.396v9.42h9.396v-9.42ZM334.489 444.863h-9.396v9.419h9.396v-9.419ZM343.885 426.023h-9.396v9.42h9.396v-9.42ZM343.885 444.863h-9.396v9.419h9.396v-9.419ZM343.885 491.961h-9.396v9.42h9.396v-9.42ZM353.28 426.023h-9.395v9.42h9.395v-9.42Z"
        />
        <path
          fill={fill}
          d="M353.28 435.443h-9.395v9.42h9.395v-9.42ZM353.28 444.863h-9.395v9.419h9.395v-9.419ZM353.28 491.961h-9.395v9.42h9.395v-9.42ZM362.676 426.023h-9.395v9.42h9.395v-9.42ZM362.676 444.863h-9.395v9.419h9.395v-9.419ZM362.676 463.702h-9.395v9.42h9.395v-9.42ZM343.949 463.702h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M343.949 473.066h-9.396v9.42h9.396v-9.42ZM362.676 473.122h-9.395v9.419h9.395v-9.419ZM362.676 482.541h-9.395v9.42h9.395v-9.42ZM296.968 506.285h-9.396v9.42h9.396v-9.42ZM372.072 444.863h-9.396v9.419h9.396v-9.419ZM372.072 482.541h-9.396v9.42h9.396v-9.42ZM381.468 435.443h-9.396v9.42h9.396v-9.42ZM381.468 454.282h-9.396v9.42h9.396v-9.42ZM390.864 444.863h-9.396v9.419h9.396v-9.419ZM390.864 463.702h-9.396v9.42h9.396v-9.42ZM400.259 426.023h-9.395v9.42h9.395v-9.42Z"
        />
        <path
          fill={fill}
          d="M400.259 435.443h-9.395v9.42h9.395v-9.42ZM409.655 426.023h-9.395v9.42h9.395v-9.42ZM409.655 454.282h-9.395v9.42h9.395v-9.42ZM409.655 463.702h-9.395v9.42h9.395v-9.42ZM419.051 444.863h-9.396v9.419h9.396v-9.419ZM427.361 411.277v9.396h9.42v-9.396h-9.42ZM446.2 411.277v9.396h9.42v-9.396h-9.42ZM427.361 401.881v9.396h9.42v-9.396h-9.42ZM427.361 435.356v9.395h9.42v-9.395h-9.42ZM427.361 425.96v9.395h9.42v-9.395h-9.42ZM455.62 401.881v9.396h9.42v-9.396h-9.42ZM507.623 279.546v9.396h9.42v-9.396h-9.42ZM446.2 392.485v9.396h9.42v-9.396h-9.42Z"
        />
        <path
          fill={fill}
          d="M455.62 392.485v9.396h9.42v-9.396h-9.42ZM465.04 392.485v9.396h9.42v-9.396h-9.42Z"
        />
        <path
          fill={fill}
          d="M455.62 383.09v9.396h9.42v-9.396h-9.42ZM465.04 383.09v9.396h9.42v-9.396h-9.42ZM427.361 373.694v9.396h9.42v-9.396h-9.42ZM446.2 373.694v9.396h9.42v-9.396h-9.42Z"
        />
        <path
          fill={fill}
          d="M455.62 373.694v9.396h9.42v-9.396h-9.42ZM427.361 364.298v9.396h9.42v-9.396h-9.42ZM446.2 364.298v9.396h9.42v-9.396h-9.42ZM474.459 364.298v9.396h9.42v-9.396h-9.42ZM483.879 364.298v9.396h9.42v-9.396h-9.42ZM436.781 354.902v9.396h9.419v-9.396h-9.419ZM455.62 354.902v9.396h9.42v-9.396h-9.42ZM474.459 354.902v9.396h9.42v-9.396h-9.42ZM436.781 345.506v9.396h9.419v-9.396h-9.419ZM474.459 345.506v9.396h9.42v-9.396h-9.42ZM493.299 345.506v9.396h9.419v-9.396h-9.419ZM436.781 336.111v9.395h9.419v-9.395h-9.419ZM493.299 336.111v9.395h9.419v-9.395h-9.419ZM427.361 326.715v9.395h9.42v-9.395h-9.42ZM465.04 326.715v9.395h9.42v-9.395h-9.42ZM436.781 317.319v9.396h9.419v-9.396h-9.419ZM483.879 317.319v9.396h9.42v-9.396h-9.42Z"
        />
        <path
          fill={fill}
          d="M493.299 317.319v9.396h9.419v-9.396h-9.419ZM446.2 307.923v9.396h9.42v-9.396h-9.42ZM465.04 307.923v9.396h9.42v-9.396h-9.42Z"
        />
        <path
          fill={fill}
          d="M474.459 307.923v9.396h9.42v-9.396h-9.42ZM493.299 307.923v9.396h9.419v-9.396h-9.419ZM427.361 298.527v9.396h9.42v-9.396h-9.42ZM436.781 298.527v9.396h9.419v-9.396h-9.419ZM446.2 298.527v9.396h9.42v-9.396h-9.42ZM455.62 298.527v9.396h9.42v-9.396h-9.42ZM465.04 298.527v9.396h9.42v-9.396h-9.42ZM493.299 298.527v9.396h9.419v-9.396h-9.419ZM427.361 289.131v9.396h9.42v-9.396h-9.42ZM436.781 289.131v9.396h9.419v-9.396h-9.419ZM446.2 289.131v9.396h9.42v-9.396h-9.42ZM465.04 289.131v9.396h9.42v-9.396h-9.42ZM483.879 289.131v9.396h9.42v-9.396h-9.42ZM446.2 279.736v9.395h9.42v-9.395h-9.42ZM493.299 279.736v9.395h9.419v-9.395h-9.419ZM436.781 270.34v9.396h9.419v-9.396h-9.419ZM446.2 270.34v9.396h9.42v-9.396h-9.42ZM483.879 270.34v9.396h9.42v-9.396h-9.42Z"
        />
        <path
          fill={fill}
          d="M436.781 260.944v9.396h9.419v-9.396h-9.419ZM455.62 260.944v9.396h9.42v-9.396h-9.42ZM427.361 251.548v9.396h9.42v-9.396h-9.42ZM446.2 251.548v9.396h9.42v-9.396h-9.42ZM455.62 251.548v9.396h9.42v-9.396h-9.42ZM465.04 251.548v9.396h9.42v-9.396h-9.42Z"
        />
        <path
          fill={fill}
          d="M474.459 251.548v9.396h9.42v-9.396h-9.42ZM493.299 251.548v9.396h9.419v-9.396h-9.419ZM507.344 251.548v9.396h9.42v-9.396h-9.42ZM427.361 242.153v9.395h9.42v-9.395h-9.42ZM455.62 242.153v9.395h9.42v-9.395h-9.42ZM436.781 232.756v9.396h9.419v-9.396h-9.419ZM446.2 232.756v9.396h9.42v-9.396h-9.42ZM474.459 232.756v9.396h9.42v-9.396h-9.42ZM483.879 232.756v9.396h9.42v-9.396h-9.42Z"
        />
        <path
          fill={fill}
          d="M493.299 232.756v9.396h9.419v-9.396h-9.419ZM446.2 223.361v9.396h9.42v-9.396h-9.42ZM455.62 223.361v9.396h9.42v-9.396h-9.42Z"
        />
        <path
          fill={fill}
          d="M493.299 223.361v9.396h9.419v-9.396h-9.419ZM427.361 213.965v9.396h9.42v-9.396h-9.42ZM474.459 213.965v9.396h9.42v-9.396h-9.42ZM436.781 204.569v9.396h9.419v-9.396h-9.419ZM446.2 204.569v9.396h9.42v-9.396h-9.42ZM455.62 204.569v9.396h9.42v-9.396h-9.42ZM465.04 204.569v9.396h9.42v-9.396h-9.42Z"
        />
        <path
          fill={fill}
          d="M474.459 204.569v9.396h9.42v-9.396h-9.42ZM493.299 204.569v9.396h9.419v-9.396h-9.419ZM436.781 195.173v9.396h9.419v-9.396h-9.419ZM446.2 195.173v9.396h9.42v-9.396h-9.42ZM427.361 185.778v9.395h9.42v-9.395h-9.42ZM446.2 185.778v9.395h9.42v-9.395h-9.42ZM493.299 185.778v9.395h9.419v-9.395h-9.419Z"
        />
        <path
          fill={fill}
          d="M427.361 176.382v9.396h9.42v-9.396h-9.42ZM436.781 176.382v9.396h9.419v-9.396h-9.419ZM446.2 176.382v9.396h9.42v-9.396h-9.42ZM493.299 176.382v9.396h9.419v-9.396h-9.419ZM427.361 166.986v9.396h9.42v-9.396h-9.42ZM446.2 166.986v9.396h9.42v-9.396h-9.42ZM465.04 166.986v9.396h9.42v-9.396h-9.42ZM465.04 186.383v9.395h9.42v-9.395h-9.42Z"
        />
        <path
          fill={fill}
          d="M474.459 166.986v9.396h9.42v-9.396h-9.42ZM483.879 166.986v9.396h9.42v-9.396h-9.42ZM446.2 157.59v9.396h9.42v-9.396h-9.42ZM483.879 157.59v9.396h9.42v-9.396h-9.42ZM436.781 148.194v9.396h9.419v-9.396h-9.419ZM455.62 148.194v9.396h9.42v-9.396h-9.42ZM446.2 138.799v9.396h9.42v-9.396h-9.42ZM465.04 138.799v9.396h9.42v-9.396h-9.42ZM427.361 129.403v9.396h9.42v-9.396h-9.42ZM436.781 129.403v9.396h9.419v-9.396h-9.419Z"
        />
        <path
          fill={fill}
          d="M427.361 120.007v9.396h9.42v-9.396h-9.42ZM455.62 120.007v9.396h9.42v-9.396h-9.42ZM465.04 120.007v9.396h9.42v-9.396h-9.42ZM446.2 110.611v9.396h9.42v-9.396h-9.42ZM440.181 97.234v9.396h9.42v-9.396h-9.42ZM105.645 411.277v9.396h-9.42v-9.396h9.42ZM86.806 411.277v9.396h-9.42v-9.396h9.42ZM105.645 401.881v9.396h-9.42v-9.396h9.42ZM105.645 435.356v9.395h-9.42v-9.395h9.42ZM105.645 425.96v9.395h-9.42v-9.395h9.42ZM77.386 401.881v9.396h-9.42v-9.396h9.42ZM25.384 279.546v9.396h-9.42v-9.396h9.42ZM86.806 392.485v9.396h-9.42v-9.396h9.42Z"
        />
        <path fill={fill} d="M77.386 392.485v9.396h-9.42v-9.396h9.42Z" />
        <path fill={fill} d="M67.967 392.485v9.396h-9.42v-9.396h9.42Z" />
        <path fill={fill} d="M77.386 383.09v9.396h-9.42v-9.396h9.42Z" />
        <path
          fill={fill}
          d="M67.967 383.09v9.396h-9.42v-9.396h9.42ZM105.645 373.694v9.396h-9.42v-9.396h9.42ZM86.806 373.694v9.396h-9.42v-9.396h9.42Z"
        />
        <path
          fill={fill}
          d="M77.386 373.694v9.396h-9.42v-9.396h9.42ZM105.645 364.298v9.396h-9.42v-9.396h9.42ZM86.806 364.298v9.396h-9.42v-9.396h9.42ZM58.547 364.298v9.396h-9.42v-9.396h9.42Z"
        />
        <path
          fill={fill}
          d="M49.127 364.298v9.396h-9.42v-9.396h9.42ZM96.226 354.902v9.396h-9.42v-9.396h9.42ZM77.386 354.902v9.396h-9.42v-9.396h9.42ZM58.547 354.902v9.396h-9.42v-9.396h9.42ZM96.226 345.506v9.396h-9.42v-9.396h9.42ZM58.547 345.506v9.396h-9.42v-9.396h9.42ZM39.708 345.506v9.396h-9.42v-9.396h9.42ZM96.226 336.111v9.395h-9.42v-9.395h9.42ZM39.708 336.111v9.395h-9.42v-9.395h9.42ZM105.645 326.715v9.395h-9.42v-9.395h9.42ZM67.967 326.715v9.395h-9.42v-9.395h9.42Z"
        />
        <path
          fill={fill}
          d="M96.226 317.319v9.396h-9.42v-9.396h9.42ZM49.127 317.319v9.396h-9.42v-9.396h9.42Z"
        />
        <path
          fill={fill}
          d="M39.708 317.319v9.396h-9.42v-9.396h9.42ZM86.806 307.923v9.396h-9.42v-9.396h9.42ZM67.967 307.923v9.396h-9.42v-9.396h9.42ZM58.547 307.923v9.396h-9.42v-9.396h9.42ZM39.708 307.923v9.396h-9.42v-9.396h9.42ZM105.645 298.527v9.396h-9.42v-9.396h9.42Z"
        />
        <path
          fill={fill}
          d="M96.226 298.527v9.396h-9.42v-9.396h9.42ZM86.806 298.527v9.396h-9.42v-9.396h9.42ZM77.386 298.527v9.396h-9.42v-9.396h9.42Z"
        />
        <path
          fill={fill}
          d="M67.967 298.527v9.396h-9.42v-9.396h9.42ZM39.708 298.527v9.396h-9.42v-9.396h9.42ZM105.645 289.131v9.396h-9.42v-9.396h9.42Z"
        />
        <path
          fill={fill}
          d="M96.226 289.131v9.396h-9.42v-9.396h9.42ZM86.806 289.131v9.396h-9.42v-9.396h9.42ZM67.967 289.131v9.396h-9.42v-9.396h9.42ZM49.127 289.131v9.396h-9.42v-9.396h9.42ZM86.806 279.736v9.395h-9.42v-9.395h9.42ZM39.708 279.736v9.395h-9.42v-9.395h9.42ZM96.226 270.34v9.396h-9.42v-9.396h9.42ZM86.806 270.34v9.396h-9.42v-9.396h9.42ZM49.127 270.34v9.396h-9.42v-9.396h9.42Z"
        />
        <path
          fill={fill}
          d="M96.226 260.944v9.396h-9.42v-9.396h9.42ZM77.386 260.944v9.396h-9.42v-9.396h9.42ZM105.645 251.548v9.396h-9.42v-9.396h9.42ZM86.806 251.548v9.396h-9.42v-9.396h9.42ZM77.386 251.548v9.396h-9.42v-9.396h9.42Z"
        />
        <path
          fill={fill}
          d="M67.967 251.548v9.396h-9.42v-9.396h9.42ZM58.547 251.548v9.396h-9.42v-9.396h9.42ZM39.708 251.548v9.396h-9.42v-9.396h9.42ZM25.662 251.548v9.396h-9.42v-9.396h9.42ZM105.645 242.153v9.395h-9.42v-9.395h9.42ZM77.386 242.153v9.395h-9.42v-9.395h9.42ZM96.226 232.756v9.396h-9.42v-9.396h9.42ZM86.806 232.756v9.396h-9.42v-9.396h9.42ZM58.547 232.756v9.396h-9.42v-9.396h9.42Z"
        />
        <path fill={fill} d="M49.127 232.756v9.396h-9.42v-9.396h9.42Z" />
        <path
          fill={fill}
          d="M39.708 232.756v9.396h-9.42v-9.396h9.42ZM86.806 223.361v9.396h-9.42v-9.396h9.42ZM77.386 223.361v9.396h-9.42v-9.396h9.42Z"
        />
        <path
          fill={fill}
          d="M39.708 223.361v9.396h-9.42v-9.396h9.42ZM105.645 213.965v9.396h-9.42v-9.396h9.42ZM58.547 213.965v9.396h-9.42v-9.396h9.42ZM96.226 204.569v9.396h-9.42v-9.396h9.42ZM86.806 204.569v9.396h-9.42v-9.396h9.42ZM77.386 204.569v9.396h-9.42v-9.396h9.42Z"
        />
        <path
          fill={fill}
          d="M67.967 204.569v9.396h-9.42v-9.396h9.42ZM58.547 204.569v9.396h-9.42v-9.396h9.42ZM39.708 204.569v9.396h-9.42v-9.396h9.42ZM96.226 195.173v9.396h-9.42v-9.396h9.42ZM86.806 195.173v9.396h-9.42v-9.396h9.42ZM105.645 185.778v9.395h-9.42v-9.395h9.42ZM86.806 185.778v9.395h-9.42v-9.395h9.42ZM39.708 185.778v9.395h-9.42v-9.395h9.42Z"
        />
        <path fill={fill} d="M105.645 176.382v9.396h-9.42v-9.396h9.42Z" />
        <path
          fill={fill}
          d="M96.226 176.382v9.396h-9.42v-9.396h9.42ZM86.806 176.382v9.396h-9.42v-9.396h9.42ZM39.708 176.382v9.396h-9.42v-9.396h9.42ZM105.645 166.986v9.396h-9.42v-9.396h9.42ZM86.806 166.986v9.396h-9.42v-9.396h9.42ZM67.967 166.986v9.396h-9.42v-9.396h9.42ZM67.967 186.383v9.395h-9.42v-9.395h9.42ZM58.547 166.986v9.396h-9.42v-9.396h9.42Z"
        />
        <path
          fill={fill}
          d="M49.127 166.986v9.396h-9.42v-9.396h9.42ZM86.806 157.59v9.396h-9.42v-9.396h9.42ZM49.127 157.59v9.396h-9.42v-9.396h9.42ZM96.226 148.194v9.396h-9.42v-9.396h9.42ZM77.386 148.194v9.396h-9.42v-9.396h9.42ZM86.806 138.799v9.396h-9.42v-9.396h9.42Z"
        />
        <path
          fill={fill}
          d="M67.967 138.799v9.396h-9.42v-9.396h9.42ZM105.645 129.403v9.396h-9.42v-9.396h9.42Z"
        />
        <path fill={fill} d="M96.226 129.403v9.396h-9.42v-9.396h9.42Z" />
        <path
          fill={fill}
          d="M105.645 120.007v9.396h-9.42v-9.396h9.42ZM77.386 120.007v9.396h-9.42v-9.396h9.42Z"
        />
        <path
          fill={fill}
          d="M67.967 120.007v9.396h-9.42v-9.396h9.42ZM86.806 110.611v9.396h-9.42v-9.396h9.42ZM436.757 92.937h-9.396v9.42h9.396v-9.42Z"
        />
        <path
          fill={fill}
          d="M436.757 102.301h-9.396v9.42h9.396v-9.42ZM96.313 100.963h-9.395v9.42h9.395v-9.42Z"
        />
        <path fill={fill} d="M105.677 100.963h-9.396v9.42h9.396v-9.42Z" />
        <path fill={fill} d="M96.313 91.6h-9.395v9.419h9.395v-9.42Z" />
        {children}
      </g>
    </svg>
  );
}
